export default __webpack_public_path__ + "static/media/884.00db71e0.png";